module.exports = __webpack_public_path__ + "media/flags/gu-b0009474.svg";